<template>
  <div>
    <div v-if="!edit && client">
      <div>
        <strong>{{client.name}}</strong>
        <p v-if="client.email" class="text-muted">{{client.email}}</p>
        <p v-if="client.created_at" class="text-muted">{{client.created_at}}</p>
      </div>
      <hr>
      <div>
        <div v-for="(phone, index) in phones" :key="index" v-if="phone.phone">
          <p><i class="icon-fa icon-fa-phone-square"></i> <strong>
            <span v-html="printPhone(phone)"/>
          </strong></p>
          <p class="text-muted" v-if="phone.phone.comment">{{phone.phone.comment}}</p>
        </div>
      </div>
      <div class="text-right">
        <button @click="editClient()" class="btn btn-info btn-sm">Редактировать</button>
      </div>
    </div>
    <div v-else>
      <div class="pb-1">
        <input type="text" class="form-control" v-model="forEdit.client.name" placeholder="Имя клиента">
      </div>
      <div v-for="(phone, index) in forEdit.phones" class="row pb-1" v-if="phone">
        <div class="col-md-5">
          <input type="text" class="form-control" v-model="phone.phone.full_phone" placeholder="Телефон">
        </div>
        <div class="col-md-7 flex phone_list">
          <div v-if="search && !forEdit.client.id">
            <vue-ladda @click="searchByPhone(index)" button-class="btn btn-sm btn-info"
                       data-style="zoom-in"
                       :loading="searchLoading">Поиск
            </vue-ladda>
          </div>
          <div v-else>
            <input type="text" class="form-control" placeholder="Комментарий к телефону" v-model="phone.phone.comment">
          </div>
          <template v-if="index === 0">
            <button @click="addPhoneRow()" class="btn btn-success btn-sm">+</button>
          </template>
          <template v-else>
            <button @click="addPhoneRow(false, index)" class="btn btn-danger btn-sm">-</button>
          </template>
        </div>
      </div>
      <hr>
      <div class="flex justify-content-between">
        <vue-ladda v-if="allowToUpdateClient" @click="updateLocalClient" button-class="btn btn-sm btn-info"
                   data-style="zoom-in"
                   :loading="savingData">Обновить клиента
        </vue-ladda>
        <button v-if="client" :disabled="savingData" @click="editClient(false)" class="btn btn-primary btn-sm">Назад</button>
      </div>
    </div>
  </div>
</template>

<script>

  import api from '@/api'
  import VueLadda from 'vue-ladda/src/vue-ladda.vue'

  export default {
    components: {
      VueLadda
    },
    props: ['client', 'phones', 'updateClient', 'search'],
    data() {
      return {
        confirmClient: {
          question: false
        },
        searchLoading: false,
        allowToUpdateClient: false,
        savingData: false,
        edit: false,
        newClient: {
          name: null,
          phones: [],
        },
        forEdit: {
          client: {name: null},
          phones: []
        },
        phonesToDelete: [],
      }
    },
    created() {
      if (!this.client) {
        this.edit = true;
        this.addPhoneRow();
      }
    },
    methods: {
      async searchByPhone(index) {
        this.searchLoading = true;
        let {data} = await api.post('/clients/searchByPhone', {
          phone: this.forEdit.phones[index].phone.full_phone
        });

        if (!data.success) {
          toastr['warning'](data.message || 'Ошибка!');
        } else {
          if (data.client) {
            if (!this.forEdit.client.id) {
              this.forEdit.client = data.client;
              this.allowToUpdateClient = true;
              this.edit = false;
              if (this.updateClient) {
                this.updateClient(data.client, [{phone: data.phone}]);
                this.searchLoading = false;
                this.edit = false;
                return;
              }

            } else {
              if (this.forEdit.client.id != data.client.id) {
                this.confirmClient.question = true;
                this.confirmClient.clientId = data.client.id;
              }
            }
          }
          if (data.phone) {
            this.forEdit.phones[index].phone = data.phone;
          }
          if (!data.client && this.forEdit.client.name) {
            this.edit = false;
          }
        }
        this.searchLoading = false;
      },
      printPhone(phone) {
        if (phone.phone && phone.phone.country_code) {
          return phone.phone.country_code + ' ' + phone.phone.phone;
        } else {
          return phone.phone.full_phone;
        }
      },
      editClient(edit = true) {
        if (!edit) {
          this.edit = false;
          return
        }
        if (!this.forEdit.client.name) {
          this.forEdit.client.name = this.client.name;
        }
        // if (!this.forEdit.phones.length) {
        this.forEdit.phones = [...this.phones];
        // }
        this.edit = true;
      },
      addPhoneRow(newPhone = true, index = 0) {
        if (newPhone) {
          this.forEdit.phones.push({
            phone: {
              full_phone: null,
              comment: null
            }
          })
        } else {
          if (this.forEdit.phones[index].id) {
            this.phonesToDelete.push(this.forEdit.phones[index].id);
          }
          delete this.forEdit.phones[index];
          this.forEdit.phones = [...this.forEdit.phones];
        }
      },
      async updateLocalClient() {
        this.savingData = true;
        let {data} = await api.post('/orders/updateClientPhones', {
          phones: this.forEdit.phones,
          client: {
            name: this.forEdit.client.name,
            id: (this.client && this.client.id) || this.forEdit.client.id || null,
          },
          orderId: this.$route.params.id || null,
          toDelete: this.phonesToDelete,
        });

        if (!data.success) {
          toastr['warning'](data.message || 'Ошибка!');
        } else {
          toastr['success']('Сохранено');

          if (this.updateClient) {
            this.updateClient(this.forEdit.client, this.forEdit.phones.map((p) => p.phone.country_code = null));
            this.edit = false;
          }

        }

        this.savingData = false;
      }
    }
  }

</script>

<style scoped>
  hr {
    margin-top: 3px;
    margin-bottom: 3px;
  }

  p {
    margin-bottom: 5px;
  }
</style>
